const Districts = () => import("../districts/views/Districts.vue");
const DistrictEdit = () => import("../districts/views/DistrictEdit.vue");

const route = "/districts";

export default [
  {
    path: route,
    name: "districts.list",
    component: Districts,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "districts.create",
    component: DistrictEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:districtId/edit`,
    name: "districts.edit",
    component: DistrictEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
